import React from "react"

function IconMenuStatusDnd({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="menu-status-dnd"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-menu-status-dnd"
      {...props}
    >
      <path
        d="M6.156 12.714a.9.9 0 0 1 .113 1.793l-.113.007H1.991a.9.9 0 0 1-.113-1.793l.113-.007h4.165zm14.4-6.03a.9.9 0 0 1 .113 1.793l-.113.007H1.991a.9.9 0 0 1-.113-1.793l.113-.007h18.565zm0-6.03a.9.9 0 0 1 .113 1.793l-.113.007H1.991A.9.9 0 0 1 1.878.66L1.99.654h18.565z"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
      <path
        d="M21.49 17.182a6.272 6.272 0 0 0-6.272-6.273 6.272 6.272 0 0 0-6.273 6.273 6.272 6.272 0 1 0 12.546 0z"
        fill={color2 || color}
        fillRule="nonzero"
      />
      <path
        d="M13.824 15.118a4.181 4.181 0 0 0 4.73 4.146 3.833 3.833 0 1 1-4.293-6.01 4.168 4.168 0 0 0-.437 1.864z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  )
}

export default IconMenuStatusDnd
